import { Button } from '@chakra-ui/button';
import React from 'react';
import { useDispatch } from 'react-redux';
import { updatePages } from '../../redux/pagesSlice';
import { UilEye } from '@iconscout/react-unicons';

const OpenCanvas = ({ viewId }) => {
	let editWindow;
	const dispatch = useDispatch();

	// function checkUserData(e) {
	//     console.log(e)
	//     if(e.key == "standaloneTestPages"){
	//         dispatch(updatePages(JSON.parse(e.newValue)))
	//     }
	// }

	// React.useEffect(() => {
	//     //caso precise enviar msg ou ref

	//     window.addEventListener('storage', checkUserData)

	//     return () => {
	//         window.removeEventListener('storage', checkUserData)
	//     }
	// }, [])

	const openCanvasWindow = () => {
		if (!editWindow || editWindow.closed) {
			editWindow = window.open('/experimental/' + viewId + '?isCanvas=true', 'Canvas');
		}
	};
	return (
		<Button
			onClick={() => openCanvasWindow()}
			borderColor="gray.200"
			lineHeight={6}
			h={'auto'}
			fontSize={'xs'}
			m={0}
			rightIcon={<UilEye color="gray.700" size={12} />}
			variant="outline"
		>
			Visualizar Projeto
		</Button>
	);
};

export default OpenCanvas;
